import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class AppIconRegistryService {
  private readonly ICON_CONFIGS = [
    { name: 'chat', path: 'chat/baseline.svg' },
    { name: 'event', path: 'event/baseline.svg' },
    { name: 'laptop', path: 'laptop/baseline.svg' },
    { name: 'contact_support', path: 'contact_support/baseline.svg' },
    { name: 'notifications', path: 'notifications/baseline.svg' },
    { name: 'menu', path: 'menu/baseline.svg' },
    { name: 'more_vert', path: 'more_vert/baseline.svg' },
    { name: 'keyboard_arrow_left', path: 'keyboard_arrow_left/baseline.svg' },
    { name: 'keyboard_arrow_down', path: 'keyboard_arrow_down/baseline.svg' },
    { name: 'search', path: 'search/baseline.svg' },
    { name: 'date_range', path: 'date_range/baseline.svg' },
    { name: 'send', path: 'send/baseline.svg' },
    { name: 'help', path: 'help/baseline.svg' },
    { name: 'email', path: 'email/baseline.svg' },
    { name: 'call', path: 'call/baseline.svg' },
    { name: 'attachment', path: 'attachment/baseline.svg' },
    {
      name: 'perm_contact_calendar',
      path: 'perm_contact_calendar/baseline.svg'
    },
    { name: 'check_circle_outline', path: 'check_circle_outline/baseline.svg' },
    { name: 'help_outline', path: 'help_outline/baseline.svg' },
    { name: 'fiber_manual_record', path: 'fiber_manual_record/baseline.svg' },
    { name: 'warning', path: 'warning/baseline.svg' },
    { name: 'close', path: 'close/baseline.svg' },
    { name: 'practice', path: 'hospital.svg' },
    { name: 'logo-di', path: 'logo-di.svg' },
    { name: 'teamChat', path: 'team_chat/icon.svg' },
    { name: 'notification_settings', path: 'notification_settings/icon.svg' },
    { name: 'stats_prod', path: 'stats/money_tracker.svg' },
    { name: 'stats_same_day_prod', path: 'stats/same_day_prod.svg' },
    { name: 'stats_prod_per_visit', path: 'stats/same_day_prod.svg' },
    { name: 'stats_collections', path: 'stats/collections.svg' },
    { name: 'stats_prod_per_hour', path: 'stats/prod_per_hour.svg' },
    { name: 'stats_hyg_visits_per_hour', path: 'stats/hyg_per_hour.svg' },
    { name: 'stats_avg_tx_presented', path: 'stats/tx_presented.svg' },
    { name: 'stats_tx_acceptance', path: 'stats/tx_acceptance.svg' },
    { name: 'stats_same_day_tx_acceptance', path: 'stats/same_day_tx.svg' },
    { name: 'stats_hyg_reappt', path: 'stats/hyg_reappt.svg' },
    { name: 'stats_np_hyg_reappt', path: 'stats/np_hyg_reappt.svg' },
    { name: 'stats_patient_acceptance', path: 'stats/patient_acceptance.svg' },
    { name: 'stats_patient_diagnostic', path: 'stats/patient_diagnostic.svg' },
    {
      name: 'stats_avg_accepted_per_patient',
      path: 'stats/avg_accepted_patient.svg'
    },
    { name: 'stats_perio_visit', path: 'stats/perio_visit.svg' },
    { name: 'stats_perio_acceptance', path: 'stats/perio_acceptance.svg' },
    { name: 'stats_perio_diagnostic', path: 'stats/perio_diagnostic.svg' },
    { name: 'stats_flouride', path: 'stats/fluoride.svg' },
    { name: 'right_arrow', path: 'right/right_arrow.svg' },
    { name: 'logout', path: 'logout.svg' },
    { name: 'settings', path: 'settings.svg' },
    { name: 'request_access', path: 'request_access.svg' },
    { name: 'patient_chat', path: 'request_access/patient_chat.svg' },
    { name: 'team_chat', path: 'request_access/team_chat.svg' },
    { name: 'analytics', path: 'request_access/analytics.svg' }
  ] as const;
  private readonly path = 'assets/icons/';
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer
  ) {}

  registerIcons(): void {
    this.ICON_CONFIGS.forEach((config) => {
      this.matIconRegistry.addSvgIcon(
        config.name,
        // NOSONAR: Safe usage - paths are predefined constants from trusted assets directory
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `${this.path}${config.path}`
        )
      );
    });
  }
}
